import { createContext, useContext } from 'react';

/**
 * «Pregúntale a Alexia» al final de cada «?» (Alex, 15 oct 2026): abre el
 * chat de Alexia del panel de Ayuda con la pregunta ya escrita y enviada
 * («¿Qué es «Materia prima»?»), igual que los ejemplos de «¿Qué quieres
 * saber?». Lo pone Layout, que es quien tiene el panel de Ayuda.
 *
 * `null` = aquí no hay chat (fuera de la aplicación, o un rol sin Alexia,
 * como cocina o el encargado): el «?» sale igual, sin el enlace.
 */
export type PreguntarAlexia = ((pregunta: string) => void) | null;

const Contexto = createContext<PreguntarAlexia>(null);

export const PreguntarAlexiaProvider = Contexto.Provider;

export function usePreguntarAlexia(): PreguntarAlexia {
  return useContext(Contexto);
}
